document.addEventListener("DOMContentLoaded", () => {
  // 二级导航切换逻辑
  // 获取左边的元素和右边的元素
  const leftNavs = document.querySelectorAll(
    ".header__inline-menu .nav-list-submenu > li"
  );
  const rightItems = document.querySelectorAll(
    ".header__inline-menu .right-nav .nav-product-list"
  );
  // 左边区域增加鼠标移入的事件
  const leftAreaEl = document.querySelector(
    ".header__inline-menu .nav-list-submenu"
  );

  const useDrawerMQL = window.matchMedia(`(max-width: 1100px)`);

  function handleScreenChange(e) {
    if (e.matches) {
      // 移动端样式
      const leftNavsMb = document.querySelectorAll(
        "#menu-drawer .nav-list-submenu > li"
      );
      const leftAreaElMb = document.querySelector(
        "#menu-drawer .nav-list-submenu"
      );
      const navWrapperEl = document.querySelector("#menu-drawer .nav-list");
      leftAreaElMb.addEventListener("click", (e) => {
        if (e.target.closest("li[data-index]") !== null) {
          let needClose = !!e.target
            .closest("li[data-index]")
            .classList.contains("active");
          leftNavsMb.forEach((item) => {
            item.classList.remove("active");
          });
          if (!needClose) {
            e.target.closest("li[data-index]").classList.add("active");
          }
        }
      });
      navWrapperEl.addEventListener("click", (e) => {
        if (e.target.closest(".first-nav") !== null) {
          e.target.closest(".first-nav").classList.toggle("active");
        }
      });
    } else {
      leftAreaEl.addEventListener("mouseover", (e) => {
        if (e.target.closest("li[data-index]") !== null) {
          const index = e.target.closest("li[data-index]").dataset.index;
          leftNavs.forEach((item) => {
            item.classList.remove("active");
          });
          e.target.closest("li[data-index]").classList.add("active");
          if (index !== undefined) {
            rightItems.forEach((item) => {
              item.style.display = "none";
            });
            rightItems[index].style.display = "block";
          }
        }
      });
    }
  }

  useDrawerMQL.addEventListener("change", handleScreenChange);
  handleScreenChange(useDrawerMQL)
});
